export class PINoticeView {
  constructor(data = {}) {
    this.noticeId = data.noticeId || 0;
    this.piNoticeId = data.piNoticeId || 0;
    this.sysNoticeState = data.sysNoticeState || null;
    this.entityId = data.entityId || 0;
    this.noticeNo = data.noticeNo || '';
    this.publishDate = data.publishDate || null;
    this.sysNoticeVersionId = data.sysNoticeVersionId || 0;
    this.isPublished = data.isPublished || false;
    this.caAssignedUser = data.caAssignedUser || null;
    this.sectionGeneral = data.sectionGeneral || null;
    this.piNoticeV2 = data.piNoticeV2 || null;
    this.isUtilityContract = data.isUtilityContract || false;
    this.conditions = data.conditions || null;
  }
}

export class PINoticeDocument {
  constructor(data = {}) {
    this.piNoticeView = data.piNoticeView ? new PINoticeView(data.piNoticeView) : null;
    this.piNoticeLots = data.piNoticeLots || null;
    this.extension = data.extension || null;
  }
}
